import React from 'react';
import {Text, View} from '@react-pdf/renderer';
import styles, {excessReductionProductsStyles} from '../../Foundations/Utils/PDFUtils';

export const ExcessReductionProductsPage1: React.FC = () => (
    <View>
        <Text style={{...styles.fontBold, ...excessReductionProductsStyles.heading}}>Excess Reduction Products</Text>
        <Text style={{...styles.fontXxs, ...styles.my4}}>This data is not available via XML connection and is obtained manually by VroomVroomVroom from pricing published by the car rental provider. It is accurate as of the date published below.</Text>
        <Text style={excessReductionProductsStyles.subHeading}>Accurate as of 15/Oct/2021</Text>
        <View style={{
            ...styles.row,
            ...{ marginTop: 10 },
            ...excessReductionProductsStyles.bordered,
            ...excessReductionProductsStyles.borderLeft,
            ...excessReductionProductsStyles.borderRight,
            ...excessReductionProductsStyles.borderTop
        }}>
            <View style={{
                ...styles.wHalf,
                ...excessReductionProductsStyles.col,
                ...excessReductionProductsStyles.bordered,
                ...excessReductionProductsStyles.borderRight
            }}>
                <Text style={{
                    ...styles.fontBold,
                    ...excessReductionProductsStyles.heading
                }}>
                    Avis
                </Text>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Standard Excess
                    </Text>
                    <Text style={{...styles.fontXs, ...excessReductionProductsStyles.mb }}>$5445 - $8640</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            Included
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Reduced Excess Amount
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$838 - $1571</Text>
                    <View>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel1,
                            ...excessReductionProductsStyles.mb
                        }}>
                            Fee Per Day
                        </Text>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel2,
                            ...excessReductionProductsStyles.mb
                        }}>
                            Small – Large: $48.11
                        </Text>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel2,
                            ...excessReductionProductsStyles.mb
                        }}>
                           Four Wheel Drive: $51.21
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Zero Excess
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$0 Excess</Text>
                    <View>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel2,
                            ...excessReductionProductsStyles.mb
                        }}>
                            Small - Large & 4WD: Fee available at the counter
                        </Text>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>Signature Series: Not available</Text>
                    </View>
                </View>
            </View>
            <View style={{...styles.wHalf, ...excessReductionProductsStyles.col}}>
                <Text style={{...styles.fontBold, ...excessReductionProductsStyles.heading}}>Budget</Text>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Standard Excess
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$5445 - $5760</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            Included
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Reduced Excess Amount
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$838 - $1152</Text>
                    <View>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel1,
                            ...excessReductionProductsStyles.mb
                        }}>
                            Fee Per Day
                        </Text>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel2,
                            ...excessReductionProductsStyles.mb
                        }}>
                            Economy - Full Size: $44.06
                        </Text>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel2
                        }}>
                            Premium AWD: $48.46
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Zero Excess
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$0 Excess</Text>
                    <View>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel1,
                            ...excessReductionProductsStyles.mb
                        }}>
                            Fee available at the counter
                        </Text>
                    </View>
                </View>
            </View>
        </View>
        <View style={{
            ...styles.row,
            ...{ marginTop: 10 },
            ...excessReductionProductsStyles.bordered,
            ...excessReductionProductsStyles.borderLeft,
            ...excessReductionProductsStyles.borderRight,
            ...excessReductionProductsStyles.borderTop
        }}>
            <View style={{
                ...styles.wHalf,
                ...excessReductionProductsStyles.col,
                ...excessReductionProductsStyles.bordered,
                ...excessReductionProductsStyles.borderRight
            }}>
                <Text style={{
                    ...styles.fontBold,
                    ...excessReductionProductsStyles.heading
                }}>
                    Bargain Car Rentals
                </Text>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Limited Protection
                    </Text>
                    <Text style={{...styles.fontXs, ...excessReductionProductsStyles.mb }}>$5000 - $7500</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            Included
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Gold Package
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$1500</Text>
                    <View>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel1,
                            ...excessReductionProductsStyles.mb
                        }}>
                            $29.99 per day - standard & commercial vehicles
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Platinum Package
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$1000 - $0</Text>
                    <View>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel2,
                            ...excessReductionProductsStyles.mb
                        }}>
                            $0 excess - $34.99 per day for standard & commercial vehicles
                        </Text>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            $1000 excess - $64.99 per day for luxury vehicles
                        </Text>
                    </View>
                </View>
            </View>
            <View style={{...styles.wHalf, ...excessReductionProductsStyles.col}}>
                    <Text style={{...styles.fontBold, ...excessReductionProductsStyles.heading}}>Dollar</Text>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Dollar Basic
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$5500 - $</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            Included
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Dollar Extra
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$38 - $115</Text>
                    <View>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel1,
                            ...excessReductionProductsStyles.mb
                        }}>
                            Fee Per Day $31.35
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Dollar Plus
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$0 Excess</Text>
                    <View>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel1,
                            ...excessReductionProductsStyles.mb
                        }}>
                            Fee Per day - $39.60
                        </Text>
                    </View>
                </View>
            </View>
        </View>
        <View style={{
            ...styles.row,
            ...excessReductionProductsStyles.bordered,
            ...excessReductionProductsStyles.borderLeft,
            ...excessReductionProductsStyles.borderRight,
            ...excessReductionProductsStyles.borderTop,
            ...excessReductionProductsStyles.borderBottom
        }}>
            <View style={{
                ...styles.wHalf,
                ...excessReductionProductsStyles.col,
                ...excessReductionProductsStyles.bordered,
                ...excessReductionProductsStyles.borderRight
            }}>
                <Text style={{
                    ...styles.fontBold,
                    ...excessReductionProductsStyles.heading
                }}>
                    Enterprise
                </Text>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Damage Liability
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$3,350.00-$5,200.00</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            Included
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Collision Damage Waiver
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$350.00-$2,750.00</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel1, ...excessReductionProductsStyles.mb}}>
                            Fee Per Day
                        </Text>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel2,
                            ...excessReductionProductsStyles.mb
                        }}>
                            $950.00 excess - $29.50 (excludes GST) - Mini, Economy, Compact, Compact SUV, Intermediate-Midsize, Intermediate-Midsize SUV, Standard, Standard SUV, Full-size, Mystery vehicle
                        </Text>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel2,
                            ...excessReductionProductsStyles.mb
                        }}>
                            $900.00 excess - $38.50 (excludes GST) - Economy special
                        </Text>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2, ...excessReductionProductsStyles.mb }}>
                            $950.00 excess - $32.45 (excludes GST) - Mini, Economy, Compact, Intermediate, Standard, Premium, Compact SUV, Intermediate SUV, Standard SUV, Economy 4WD, Intermediate SUV Hybrid, Full-size Hybrid, Intermediate Hybrid, Standard Hybrid
                        </Text>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            $1,250.00 excess -  $41.80 (excludes GST) - Premium Passenger Van, Full-size SUV, Special SUV, Premium special
                        </Text>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            $1,500.00 excess - $44.00 (excludes GST) - Luxury 4-Door
                        </Text>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            $2,750.00 excess -  $44.00 (excludes GST) - Premium SUV, Pickup Truck, Pickup 2-Door, Compact Special, Full-size Truck, Luxury SUV, Compact Truck, Intermediate Truck, HD Cargo, Cube Moving Van
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Super Collision Damage Waiver
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$0 excess</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel1, ...excessReductionProductsStyles.mb }}>
                            Fee Per Day
                        </Text>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel2,
                            ...excessReductionProductsStyles.mb
                        }}>
                            $45.65 (excludes GST) - Mini, Economy, Compact, Compact SUV, Intermediate SUV, Intermediate SUV Hybrid, Intermediate-Midsize, Intermediate-Midsize SUV, Standard, Standard SUV, Full-size, Premium, Special
                        </Text>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel2,
                            ...excessReductionProductsStyles.mb
                        }}>
                            $50.01 (excludes GST) -Economy Special
                        </Text>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel2
                        }}>
                            $66.00 (excludes GST) - Premium Passenger Van, Full-size SUV, Premium SUV, Pickup Truck, Special SUV, Compact Special, Luxury, Premium Special, Full-size Truck, Luxury SUV, Compact Truck, Intermediate Truck, HD Cardo, Cube Moving Van, Dual Cab UTE
                        </Text>
                    </View>
                </View>
            </View>
            <View style={{
                ...styles.wHalf,
                ...excessReductionProductsStyles.col,
                ...excessReductionProductsStyles.bordered
            }}>
                <Text style={{
                    ...styles.fontBold,
                    ...excessReductionProductsStyles.heading
                }}>
                    Europcar
                </Text>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Basic Standard Cover
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$5,500 - $9,570</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            Included
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Medium Cover
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$1,100-$2,200</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel1, ...excessReductionProductsStyles.mb }}>
                            Fee Per Day
                        </Text>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel2,
                            ...excessReductionProductsStyles.mb
                        }}>
                            $59.75 - $74.33 depending on the vehicle class and number of days
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Premium Cover
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$0-$1,100</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel1, ...excessReductionProductsStyles.mb }}>
                            Fee Per Day
                        </Text>
                        <Text style={{
                            ...styles.fontXxs,
                            ...excessReductionProductsStyles.indentLevel2,
                            ...excessReductionProductsStyles.mb
                        }}>
                            $71.41 - $88.90 depending on the vehicle class and number of days
                        </Text>
                    </View>
                </View>
            </View>
        </View>
        <View style={{
            ...styles.row,
            ...{ marginTop: 10 },
            ...excessReductionProductsStyles.bordered,
            ...excessReductionProductsStyles.borderLeft,
            ...excessReductionProductsStyles.borderRight,
            ...excessReductionProductsStyles.borderTop,
            ...excessReductionProductsStyles.borderBottom
        }}>
            <View style={{
                ...styles.wHalf,
                ...excessReductionProductsStyles.col,
                ...excessReductionProductsStyles.bordered,
                ...excessReductionProductsStyles.borderRight
            }}>
                <Text style={{
                    ...styles.fontBold,
                    ...excessReductionProductsStyles.heading
                }}>
                    Everything Fleet
                </Text>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Standard Cover
                    </Text>
                    <Text style={{...styles.fontXs, ...excessReductionProductsStyles.mb}}>$4,900 - $5,500</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            Included
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Extra Cover
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$880 - $1,100</Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel1, ...excessReductionProductsStyles.mb }}>
                        $16.50 per day depending upon type of vehicle, age of customer etc
                    </Text>
                </View>
            </View>
            <View style={{
                ...styles.wHalf,
                ...excessReductionProductsStyles.col,
                ...excessReductionProductsStyles.bordered,
                ...excessReductionProductsStyles.borderRight
            }}>
                <Text style={{
                    ...styles.fontBold,
                    ...excessReductionProductsStyles.heading
                }}>
                    Hertz
                </Text>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Accident Damage Excess (ADE)
                    </Text>
                    <Text style={{...styles.fontXs, ...excessReductionProductsStyles.mb}}>$5,500 - $8,800</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            Included
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Accident Excess Reduction (AER)
                    </Text>
                    <Text style={{...styles.fontXs, ...excessReductionProductsStyles.mb}}>Reduced ADE</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel1, ...excessReductionProductsStyles.mb }}>
                            Fee Per Day
                        </Text>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            Standard - $26.99
                        </Text>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            Prestige / Adrenaline - $34.00
                        </Text>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            4WD / AWD / Light Trucks & Vans - $34.00
                        </Text>
                    </View>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Maximum Protection Cover (SuperCover)
                    </Text>
                    <Text style={{...styles.fontXs, ...excessReductionProductsStyles.mb}}>$0 Excess</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel1, ...excessReductionProductsStyles.mb }}>
                            Fee Per Day
                        </Text>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            Standard - $46.00
                        </Text>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            Prestige / Adrenaline - $60.00
                        </Text>
                    </View>
                </View>
            </View>
        </View>
        <View style={{
            ...styles.row,
            ...{ marginTop: 10 },
            ...excessReductionProductsStyles.bordered,
            ...excessReductionProductsStyles.borderLeft,
            ...excessReductionProductsStyles.borderRight,
            ...excessReductionProductsStyles.borderTop,
            ...excessReductionProductsStyles.borderBottom
        }}>
            <View style={{
                ...styles.wHalf,
                ...excessReductionProductsStyles.col,
                ...excessReductionProductsStyles.bordered,
                ...excessReductionProductsStyles.borderRight
            }}>
                <Text style={{
                    ...styles.fontBold,
                    ...excessReductionProductsStyles.heading
                }}>
                    No Birds
                </Text>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Damage Fee
                    </Text>
                    <Text style={{...styles.fontXs, ...excessReductionProductsStyles.mb}}>$5000</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            Included
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Damage Waiver
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$0</Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel1, ...excessReductionProductsStyles.mb }}>
                        Per day fee - $7.00
                    </Text>
                </View>
            </View>
            <View style={{
                ...styles.wHalf,
                ...excessReductionProductsStyles.col,
                ...excessReductionProductsStyles.bordered,
                ...excessReductionProductsStyles.borderRight
            }}>
                <Text style={{
                    ...styles.fontBold,
                    ...excessReductionProductsStyles.heading
                }}>
                    Sixt
                </Text>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Standard Loss Damage Waiver
                    </Text>
                    <Text style={{...styles.fontXs, ...excessReductionProductsStyles.mb}}>$4950</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            Included
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Premium Protection
                    </Text>
                    <Text style={{...styles.fontXs, ...excessReductionProductsStyles.mb}}>$880</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel1, ...excessReductionProductsStyles.mb }}>
                            $31.35 per day
                        </Text>
                    </View>
                </View>
            </View>
        </View>
        <View style={{
            ...styles.row,
            ...{ marginTop: 10 },
            ...excessReductionProductsStyles.bordered,
            ...excessReductionProductsStyles.borderLeft,
            ...excessReductionProductsStyles.borderRight,
            ...excessReductionProductsStyles.borderTop,
            ...excessReductionProductsStyles.borderBottom
        }}>
            <View style={{
                ...styles.wHalf,
                ...excessReductionProductsStyles.col,
                ...excessReductionProductsStyles.bordered,
                ...excessReductionProductsStyles.borderRight
            }}>
                <Text style={{
                    ...styles.fontBold,
                    ...excessReductionProductsStyles.heading
                }}>
                    Thrifty
                </Text>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Basic Protection
                    </Text>
                    <Text style={{...styles.fontXs, ...excessReductionProductsStyles.mb}}>$5,500 - $6,001</Text>
                    <View>
                        <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel2 }}>
                            Included
                        </Text>
                    </View>
                </View>
                <View style={{ ...excessReductionProductsStyles.mb }}>
                    <Text style={{
                        ...styles.fontBold,
                        ...excessReductionProductsStyles.subHeading,
                        ...excessReductionProductsStyles.grayText
                    }}>
                        Premium Protection
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>$850-$1,000</Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.mb}}>Fee Per day</Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel1, ...excessReductionProductsStyles.mb }}>
                        Standard Vehicles - $39.60
                    </Text>
                    <Text style={{...styles.fontXxs, ...excessReductionProductsStyles.indentLevel1, ...excessReductionProductsStyles.mb }}>
                        Prestige, Adrenaline & 4x4 Vehicles - $48.30
                    </Text>
                </View>
            </View>
        </View>
    </View>
);
